/**
 * Entry point for all public APIs of the package.
 */
export {PersistenceService,ICache,AbstractCachedService,IPersistenceContainer,PersistenceConfig,CacheConfig,ItemDefinition,StorageType,PersistenceModule} from './src/angular-persistence';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
